import { BuildClass, Do } from '../../../universal';
import { _, React } from '../../lib';
import { List } from './list';
import { ConditionalObject, useStateSync } from './meta-types';
import { ResizeSplitter } from './resize-split';
import { stubResizeSplitterInstance } from './stubs';
const DEFAULT_WIDTH = 160;
const SidebarControlCmpt = (props, ref) => {
    const [value, setValue] = React.useState(props.value);
    useStateSync({
        stateVal: value,
        propVal: props.value,
        setState: setValue,
        setProp: props.onUpdate,
        compareFn: (a, b) => a == b,
    });
    const [widths, setWidths] = React.useState(props.widths);
    useStateSync({
        propVal: props.widths,
        stateVal: widths,
        setProp: props.onUpdateWidths ?? _.noop,
        setState: setWidths,
    });
    const buildClass = BuildClass(['ui5-sidebar', props.className]);
    const buildSidebar = (React.createElement(List, { className: "sidebar", value: value, onUpdate: setValue, multiple: false, height: 30, rows: _.compact([
            ConditionalObject(Boolean(props.newLabel), {
                value: -1,
                className: 'new',
                height: 41,
                content: () => React.createElement("div", { className: "new-inner" }, props.newLabel),
            }),
            ...props.items.map(x => ({
                value: x.value,
                className: x.className,
                content: () => props.onDelete != null && (x.deletable ?? false) ? (React.createElement("div", { className: "flex" },
                    React.createElement("span", { className: "flex-1 max-w-[calc(100%-16px)] text-ellipsis overflow-hidden" }, x.text),
                    React.createElement("span", { className: "flex-1 max-w-4 max-h-4 hover:bg-red-400" },
                        React.createElement("img", { src: "/static/img/i8/color-trash-delete.svg", alt: "Delete Item", onClick: e => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (props.onDelete == null) {
                                    console.error('Cannot delete item without onDelete function');
                                    return;
                                }
                                if (x.value == -1) {
                                    console.error('Cannot delete new item');
                                    return;
                                }
                                props.onDelete(x.value);
                            } })))) : (React.createElement(React.Fragment, null, x.text)),
            })),
        ]) }));
    const buildForm = Do(() => {
        if (value || props.showFormOnNull) {
            return props.buildForm(value);
        }
        else if (props.stubMessage != null) {
            return (React.createElement("div", { className: "stub-message-wrapper" },
                React.createElement("div", { className: "stub-message" }, props.stubMessage)));
        }
        return React.createElement("div", null);
    });
    const elRef = React.useRef(stubResizeSplitterInstance);
    React.useImperativeHandle(ref, () => ({
        getElement: () => elRef.current.getElement(),
        getResizeSplitter: () => elRef.current,
    }));
    const paneSizing = {
        defaultWidth: props.pane?.defaultWidth ?? DEFAULT_WIDTH,
        minWidth: props.pane?.minWidth ?? DEFAULT_WIDTH,
        maxWidth: props.pane?.maxWidth ?? null,
        collapsible: props.pane?.collapsible ?? false,
    };
    return (React.createElement(ResizeSplitter, { value: widths, onUpdate: setWidths, className: buildClass, ref: elRef, panes: [
            {
                defaultWidth: paneSizing.defaultWidth,
                minWidth: paneSizing.minWidth,
                maxWidth: paneSizing.maxWidth,
                flexWidth: null,
                collapsible: paneSizing.collapsible,
                content: buildSidebar,
            },
            {
                defaultWidth: null,
                minWidth: null,
                maxWidth: null,
                flexWidth: 1,
                collapsible: false,
                content: React.createElement("div", { className: "ui5-sidebar-form" }, buildForm),
            },
        ] }));
};
export const SidebarControl = React.forwardRef(SidebarControlCmpt);
//# sourceMappingURL=sidebar.js.map